<template>
    <div class="btn-container">
        <v-btn
            :class="activeDisabled()"
            small
            tile
            color="#6c98ba"
            :disabled="disabled"
            @click="changeStatus(true)"
            :outlined="!status"
            width="100px"
            height="38px">
            {{ $vuetify.lang.t('$vuetify.toggleStatus.active') }}
        </v-btn>
        <v-btn
            :class="inactiveDisabled()"
            small
            tile
            color="#ff544a"
            :disabled="disabled"
            @click="changeStatus(false)"
            :outlined="status"
            width="100px"
            height="38px">
            {{ $vuetify.lang.t('$vuetify.toggleStatus.inactive') }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'ToggleStatus',

    props: {
        value: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            status: this.value,
            activeBtnColor: '',
            inactiveBtnColor: ''
        }
    },

    methods: {
        changeStatus (status) {
            this.status = status
            this.$emit('input', this.status)
        },
        activeDisabled () {
            if (this.disabled) {
                return this.status ? 'btn-active btn-active-disabled' : 'btn-active'
            } else {
                return 'btn-active'
            }
        },
        inactiveDisabled () {
            if (this.disabled) {
                return this.status ? 'btn-inactive' : 'btn-inactive btn-inactive-disabled'
            } else {
                return 'btn-inactive'
            }
        }
    },

    watch: {
        value (newValue, oldValue) {
            this.status = newValue
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-container {
    .btn-active {
        color: white;
        border-radius: 20px 0px 0px 20px;
    }
    .btn-inactive {
        color: white;
        border-radius: 0px 20px 20px 0px;
    }
    .btn-active-disabled {
        background-color: #e6eff8;
    }
    .btn-inactive-disabled {
        background-color: #f6e8e8;
    }
}
</style>
